"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import {
  Button,
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
  TypographyH4,
  TypographyText,
} from "@workspace/frontend-ui";
import type { FC, MouseEvent, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  // The wrapper still eats a flex gap slot when its child renders nothing — pass `hidden` to avoid that.
  hidden?: boolean;
}>;

const LoginIntro: FC<Props> = ({ children, hidden = false }) => {
  const { requestAuth, isLoggedIn, t } = useGamePageData();

  // Capture phase so the click never reaches the wrapped control — the only route to auth on touch.
  const handleClickCapture = (event: MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
    requestAuth();
  };

  if (isLoggedIn) return <>{children}</>;

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <span
          data-testid="login-gate"
          className={hidden ? "hidden" : undefined}
          onClickCapture={handleClickCapture}
        >
          {children}
        </span>
      </HoverCardTrigger>
      <HoverCardContent
        side="top"
        align="end"
        className="bg-secondary text-center min-w-[171px] max-h-[246px]"
      >
        <TypographyH4 isBold>
          {t("game.auth.gatetitle", "Authenticate")}
        </TypographyH4>
        <TypographyText>
          {t("game.auth.gatedescription", "To proceed")}
        </TypographyText>
        <Button className="w-full mt-2" onClick={() => requestAuth()}>
          {t("game.auth.gatebutton", "Authenticate")}
        </Button>
      </HoverCardContent>
    </HoverCard>
  );
};

export default LoginIntro;
